import { mergeClasses } from '@blank/utilities'
import { useTranslation } from 'modules/common/hooks/useTranslation'
import useSupportModal from 'modules/common/modals/useSupportModal/useSupportModal'
import { useRouter } from 'next/router'
import { Illustration } from '../Illustrations/Illustration'
import { Seo } from '../Seo/Seo'
import { IconReload } from '../_icons/icons'
import { Button } from '../_ui/Button/Button'

interface Props {
  onReload?: () => void
  className?: string
  title?: string
  firstDescription?: string
  secondDescription?: string
}

export const ErrorReload = ({
  onReload,
  className,
  title,
  firstDescription,
  secondDescription,
}: Props) => {
  const { t } = useTranslation('common')
  const router = useRouter()
  const { showModal: showSupportModal } = useSupportModal()

  return (
    <div
      className={mergeClasses(
        'flex h-full w-full items-center justify-center',
        className
      )}
      data-testid="error-reload"
    >
      <Seo title={t('meta.errorTitle')} />
      <div className="flex max-w-2xl flex-col items-center justify-center">
        <Illustration name="error" size="s" />
        <h2 className="my-4 text-center">
          {title || t('errors.reloadContent.title')}
        </h2>
        <div className="mb-8 space-y-8 text-center text-lg text-info-400">
          <p>
            {firstDescription || t('errors.reloadContent.firstDescription')}
          </p>
          <p>
            {secondDescription || t('errors.reloadContent.secondDescription')}
          </p>
        </div>
        <div className="flex space-x-4">
          <Button
            variant="secondary"
            color="default"
            type="button"
            onClick={showSupportModal}
          >
            {t('errors.reloadContent.cta.support')}
          </Button>
          <Button
            className="flex flex-row items-center justify-center"
            variant="primary"
            color="default"
            onClick={onReload || router?.reload}
            icon={<IconReload className="h-6 w-6" />}
          >
            <span>{t('errors.reloadContent.cta.reload')}</span>
          </Button>
        </div>
      </div>
    </div>
  )
}
